import { NAT_NUM_90_99 } from "../../../../SubjectData/BasicWords/Numbers/NatNums.js";
import "../../../Deck.css";
import FlashcardInterface from "../../../Flashcard_Interface.js";
import HeaderNav from "../../../../Components/Header/Header_Nav/Header_Nav.js";

export default function NAT_NUM_90_99_DECK() {
  return (
    <>
      <HeaderNav GoBack_to="/NumbersNav" />
      <FlashcardInterface deckData={NAT_NUM_90_99} title="Native Numbers: 90-99" />
    </>
  );
}
